//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import DetailedView from "./components/DetailedView.vue";
import { Feedback } from "@/utils/notify-toaster.js";

//rules.system_settings
// system_settings: this.can("system_settings"),
// admin_general: this.can("admin_general"),
// preview_version: this.can("preview_version"),
// data_settings: this.can("data_settings"),
// client_data_settings: this.can("client_data_settings"),
// client_uploads: this.can("client_uploads"),
// general: this.can("general"),
// self_settings: this.can("self_settings")

export default {
    name: "FileMappings",
    components: { DetailedView },
    beforeCreate() {
        BackendServices.getFileOrigins().then(({ data }) => {
            this.fileOrigins = data;
        });
        let pagination = {
            page: 1,
            rowsPerPage: 1000,
            raw: true
        };
        BackendServices.getFileUploadMappings(pagination).then(response => {
            this.originalMappings = response.data;
            this.splitIncomingMappings(this.originalMappings);
        });
    },

    mounted() {

    },

    data: () => ({
        hover: false,
        recordsTotal: 0,
        activeObject: {},
        activeMappings: [],
        disabledMappings: [],
        showStructureMappings: false,
        fileOrigins: [],
        originalMappings: [],
    }),

    methods: {
        editMapping(mapping) {
            this.activeObject = mapping;
        },
        splitIncomingMappings(mappings) {
            if (!this.showStructureMappings) {
                mappings = this.excludeStructureMapping(mappings);
            }
            for (const obj of mappings) {

                if (obj.disabled) {
                    this.disabledMappings.push(obj);
                } else {
                    this.activeMappings.push(obj);
                }
            }
        },
        excludeStructureMapping(mappings) {
            return mappings.filter(obj => obj.file_origin_id != this.fileOrigins.find(obj => obj.name === "Setup").id);
        },
        changeMappingState(mapping) {
            this.activeObject = {}
            if (mapping.disabled) {
                mapping.disabled = false;
                BackendServices.updateExistingMapping(mapping).then(() => {
                    this.disabledMappings = this.disabledMappings.filter(obj => obj.id != mapping.id);
                    this.activeMappings.push(mapping);
                });
            } else {
                mapping.disabled = true;
                BackendServices.updateExistingMapping(mapping).then(() => {
                    this.activeMappings = this.activeMappings.filter(obj => obj.id != mapping.id);
                    this.disabledMappings.push(mapping);
                });
            }
        },
        updateData(object) {
            try {
                BackendServices.updateExistingMapping(object);
                this.activeObject = {}
                return Feedback.success("Mapeamento atualizado com sucesso.");
            } catch (error) {
                return Feedback.error("Ocorreu um erro ao atualizar o mapeamento.");
            }
        },
    },
    computed: {
        numberOfActiveMappings() {
            return this.activeMappings.length;
        },
        numberOfDisabledMappings() {
            return this.disabledMappings.length;
        },
        isAdmin() {
            return this.can("system_settings")
        },
        activeMappingClass() {
            if (this.isAdmin){
                return "col-2 q-ml-xl"
            }else{
                return "col-4 q-ml-xl"
            }
        }
    },
    watch: {
        showStructureMappings() {
            this.activeMappings = [];
            this.disabledMappings = [];
            this.splitIncomingMappings(this.originalMappings);
        }
    }

}

